const removeItemByKey = async (key) => {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 }),
  });
};

const handleCustomCartLogic = async () => {
  const cart = await fetch('/cart.js').then((r) => r.json());

  const starterSetItem = cart.items.find((item) => item.properties?.bundle_root === 'StarterSet');
  const starterSetKey = starterSetItem?.key;

  const bundleItems = cart.items.filter((item) => item.properties?.bundle_attached_to === 'StarterSet');
  const bundleKeys = bundleItems.map((item) => item.key);

  // Generischer Schutz: JEDES Cart-Item, das ein 'bundle_attached_to'
  // Property hat (egal zu welchem Bundle - StarterSet, BestsellerMixSet,
  // etc.), bekommt Subscription-Wechsel, Mengen-Aenderung und Entfernen
  // gesperrt. Vorher war das hart auf 'StarterSet' codiert, wodurch z.B.
  // die Bestseller-Mix-Set-Nachfuellpackungen (Sale-Buy-Box) ungeschuetzt
  // waren und Kunden dort manuell auf einen anderen/guenstigeren Plan
  // haetten wechseln koennen.
  document.querySelectorAll('.slidecarthq .item').forEach((el) => {
    const id = parseInt(el.dataset.variantId, 10);
    const isBundleAttachedItem = cart.items.some(
      (i) => i.variant_id === id && i.properties?.bundle_attached_to
    );
    if (isBundleAttachedItem) {
      el.querySelector('.upgrade-to-subscription')?.classList.add('hidden');
      el.querySelector('.quantity-selector')?.classList.add('hidden');
      el.querySelector('.remove')?.setAttribute('disabled', 'disabled');
    }
  });

  // Gratis-Beigabe-Items (z.B. Bio-Antioxidant Mix, der beim Kennenlern-Set-
  // Kauf automatisch mit properties:{'_bundle':'Kennenlern-Set'} und Preis
  // 0 EUR hinzugefuegt wird) bekommen nur den "Spare X% im flexiblen Abo"-
  // Button der AMP-App ausgeblendet - das Item ist bereits kostenlos, ein
  // Abo-Upsell darauf ergibt inhaltlich keinen Sinn. Mengen-Steuerung und
  // Entfernen-Button bleiben bewusst unangetastet (anders als beim
  // 'bundle_attached_to'-Schutz oben), da das nicht Teil dieser Korrektur
  // ist. Abgleich ueber den exakten Line-Item-Key (variant_id:properties-
  // hash) statt nur variant_id, damit ein regulaer gekauftes Bio-
  // Antioxidant-Mix (ohne '_bundle'-Property, andere Property-Hash also
  // anderer Key) im selben Warenkorb unberuehrt bliebe.
  document.querySelectorAll('.slidecarthq .item').forEach((el) => {
    const key = el.dataset.lineItemKey;
    const isFreeBundleGiftItem = cart.items.some(
      (i) => i.key === key && i.properties?._bundle
    );
    if (isFreeBundleGiftItem) {
      el.querySelector('.upgrade-to-subscription')?.classList.add('hidden');
    }
  });

  // Generisches Sicherheitsnetz (fuer ALLE Bundles ausser 'StarterSet',
  // das seine eigene, komplexere Logik weiter unten hat): fuer jede
  // Gruppe von Anhang-Artikeln (gruppiert nach ihrem 'bundle_attached_to'
  // Wert) wird geprueft, ob im Cart noch ein passender Root-Artikel
  // (properties.bundle_root === derselbe Wert) existiert. Fehlt der
  // Root-Artikel (z.B. weil der Kunde das Hauptprodukt aus dem Warenkorb
  // entfernt hat), werden alle zugehoerigen Anhang-Artikel automatisch
  // mitentfernt. Das verhindert, dass jemand nur mit den (kostenlosen)
  // Zubehoer-/Nachfuell-Artikeln zur Kasse geht, ohne das Hauptprodukt
  // bezahlt zu haben.
  const attachedGroups = new Map();
  cart.items.forEach((item) => {
    const groupName = item.properties?.bundle_attached_to;
    if (groupName && groupName !== 'StarterSet') {
      if (!attachedGroups.has(groupName)) attachedGroups.set(groupName, []);
      attachedGroups.get(groupName).push(item);
    }
  });

  for (const [groupName, groupItems] of attachedGroups) {
    const hasMatchingRoot = cart.items.some((item) => item.properties?.bundle_root === groupName);
    if (!hasMatchingRoot) {
      for (const item of groupItems) await removeItemByKey(item.key);
      window.SLIDECART_UPDATE?.();
    }
  }

  if (!starterSetItem && bundleItems.length > 0) {
    for (const key of bundleKeys) await removeItemByKey(key);
    window.SLIDECART_UPDATE?.();
    return;
  }

  // Ohne StarterSet-Hauptartikel im Cart gibt es hier nichts mehr zu tun -
  // frueher fehlte dieser Guard, wodurch der Zugriff auf
  // starterSetItem.properties weiter unten einen TypeError warf, sobald
  // ueberhaupt kein StarterSet-Artikel im Cart war (z.B. bei der Sale-Buy-
  // Box, die gar kein StarterSet verwendet).
  if (!starterSetItem) return;

  // Bugfix 2026-09-23 (Checkout-Redirect-auf-Homepage bei 30-Tage-Abos): der
  // bisherige "allAttachedCount"-Check wurde ENTFERNT (nicht gepatcht, siehe
  // Praezedenzfall/Begruendung in claude/atc-cart-wipe-bug-90-tage-abo-sept2026.md
  // - dort war exakt dieser Check laut Doku bereits einmal entfernt worden,
  // war im aktuellen Code aber weiterhin aktiv). Ursache: window.bundleItems /
  // window.bundleItemsAdditional werden in der Flexplan-Buybuttons-Snippet nur
  // dann mit Eintraegen befuellt, wenn fuer den aktuell gewaehlten Abo-Plan ein
  // NAMENSGLEICHES selling_plan_allocation auf den konfigurierten "bundle_products"
  // existiert. Sobald fuer ein Ein-Artikel-Bundle OHNE echte bundle_attached_to-
  // Anhaenge (z.B. Bestseller-Mix-Pads 30-Tage-Abo) ueberhaupt ein Recharge-Plan
  // existiert, wurde dieser Zaehler > 0, waehrend die reale Cart-Anzahl (bundleItems.
  // length) immer 0 blieb -> der gerade hinzugefuegte Abo-Artikel wurde sofort per
  // /cart/change.js (quantity 0) wieder aus dem Cart entfernt. Ergebnis: leerer
  // Warenkorb im Moment des Klicks auf "Zum Checkout" -> Shopify leitet /checkout
  // bei leerem Cart auf die Startseite um. Das generische, robustere Sicherheitsnetz
  // weiter oben (Zeilen 58-83, Abgleich direkt gegen die echten Cart-Properties statt
  // gegen diese veralteten window-Globals) deckt den eigentlich beabsichtigten Schutz
  // (verwaiste Anhang-Artikel ohne Root-Artikel entfernen) weiterhin ab.
};

const observer = new MutationObserver(() => {
  handleCustomCartLogic();
});

const waitForCartElement = () => {
  const cartRoot = document.querySelector('.slidecarthq');

  if (cartRoot) {
    observer.observe(cartRoot, {
      childList: true,
      subtree: true,
    });
    handleCustomCartLogic();
  } else {
    setTimeout(waitForCartElement, 300);
  }
};

document.addEventListener('DOMContentLoaded', waitForCartElement);
